export enum LinkType {
  LINK_TYPE_WEB = 'link-web',
  LINK_TYPE_DOC = 'link-document',
  LINK_TYPE_MEDIA = 'link-media',
}

type BaseLink = {
  linkType: string;
};

export type LinkDocument = BaseLink & {
  type: string;
  id: string;
  lang: string;
  uid?: string;
};

export type LinkWeb = BaseLink & {
  url: string;
};

export type LinkMedia = BaseLink & {
  name: string;
  url: string;
  size: string;
  kind?: string;
};

export type Link = LinkDocument | LinkWeb | LinkMedia | undefined;
